import template from "./target_vs_actual_time_report.html";
import * as Utils from "../../lib/savanna_utils.js";
import tr from '../../lib/default-translator.js';

class TargetVsActualHoursViewModel
{
	constructor(page)
	{
		this.page = page;

		let first_day = moment().format("YYYY-MM-01");
		let last_day = moment().format("YYYY-MM-") + moment().daysInMonth();
		this.loader = ko.observable();

		this.outstanding_hours_in_department = ko.observable(0);
		this.total_hours_in_department = ko.observable(0);
		this.outstanding_hours = ko.observable(0);
		this.overtime = ko.observable(0);
		this.annual_summary = ko.observableArray([]);
		this.selected_graph_options = ko.observableArray([0]);
		this.refresh_button = ko.observable(false),

		this.date_start = ko.observable(new Date(first_day).toJSON().slice(0, 10));
		this.date_end = ko.observable(new Date(last_day).toJSON().slice(0, 10));

		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();

		this.options = ko.observableArray([
			{ id: 0, name: "Target vs Actual", selected: true },
			{ id: 1, name: "Overtime vs Outstanding", selected: false },
		]);

		this.selected_graph_options.subscribe((val) => {
			this.page.updateData();
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});
		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.date_start.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout) 
				clearTimeout(this.start_date_timeout);
			

			// Set new timeout to wait for user to finish typing or selecting date
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, "YYYY-MM-DD", true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.date_end(month_end);

				this.page.updateData();
			}, 500);
		});

		this.date_end.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout) 
				clearTimeout(this.end_date_timeout);
			

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, "YYYY-MM-DD", true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.date_start(), "YYYY-MM-DD", true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({
							type: 'error',
							title: tr('Invalid Date Range'),
							message: tr('End date cannot be before start date')
						});
						return;
					}
					this.page.updateData();
				}
			}, 1000);
		});

		this.selected_options_text = ko.computed(() => {
			let selected_ids = this.selected_graph_options();
			if (selected_ids.length === 0) return "View time logged options";
			
			if (selected_ids.length > 3) return `${selected_ids.length} options selected`;
		
			let selected_names = this.options().filter(option => selected_ids.includes(option.id)).map(option => option.name);
			return selected_names.join(", ");
		});
	}

	calculate_total_target_hours()
	{
		return this.annual_summary().reduce(function (acc, employee) {
			return acc + employee.target_hours;
		}, 0);
	}

	calculate_total_actual_hours()
	{
		return this.annual_summary().reduce(function (acc, employee) {
			return acc + employee.total_hours;
		}, 0);
	}

	/* not used currently
	remove_filter(v, e)
	{
		if ($(e.currentTarget).prop("checked") == false)
			this.selected_graph_options.remove(v.id);
		else
		{
			if (this.selected_graph_options.indexOf(v.id) == -1)
				this.selected_graph_options.push(v.id);
		}

		this.refresh_button(true);
		return true;
	}
	*/

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	graph_option_click (row)
	{
		let selected_options = this.selected_graph_options();

		if (selected_options.indexOf(row.id) == -1)
			this.selected_graph_options.push(row.id);
		else
			this.selected_graph_options.remove(row.id);

		this.refresh_button(true);
		return true;
	}

	async download_clicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('attendance_report'));
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;
		
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'attendance_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	show_report_help()
	{
		Grape.dialog.open("AttendanceDepartmentHelp", { employee_id: this.page.bindings.id });
	}
}

class TargetVsActualHoursPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new TargetVsActualHoursViewModel(this);
		this.chart;
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied("DepartmentsAvgLeaveComparisonReport"))
			return;

		document.title = tr('Attendance Report');
		window.current_page_title(tr('Attendance Report Per Department'));

		this.setupGraph();
		this.updateData();
	}

	async updateData()
	{
		if (this.viewModel.date_start() != "" && this.viewModel.date_start() != undefined && this.viewModel.date_end() != "" && this.viewModel.date_end() != undefined)
		{
			let data = {
				date_start: this.viewModel.date_start(),
				date_end: this.viewModel.date_end(),
				department_id: this.viewModel.current_department_id(),
			};

			this.viewModel.loader(true);
			let res = await Grape.fetches.postJSON("/reports/time_and_attendance_report", data);

			if (!res || res.result === null)
				this.viewModel.annual_summary([]);
			else
				this.viewModel.annual_summary(res);

			this.buildGraph(res);
			this.viewModel.loader(false);
			this.viewModel.refresh_button(false);
		}
		else
			Grape.alerts.alert({type: "error", title: "Error", message: error.message});
	}

	setupGraph()
	{
		this.chart = c3.generate({
			size: {
				height: 400,
			},
			data: {
				x: "x",
				columns: [
					/* ['x', 'Platsoft', 'Skinchem', 'Maths', 'IG' , 'QC' , 'Platlife' , 'Platsoft', 'Skinchem', 'Maths', 'IG' , 'QC' , 'Platlife'],
					['Leave %', 30, 70, 100, 100, 100, 50, 30, 70, 100, 100, 100, 50] */
				],
				colors: {
					"Total Hours ": "#31859D",
				},
				type: "bar",
				labels: {
					format: {
						// "Leave %": d3.format('%')
						"Total hours ": function (v, id, i, j) {
							return v + "";
						},
					},
				},
			},
			transition: {
				duration: 1000,
			},
			legend: {
				show: false,
			},
			bar: {
				width: {
					ratio: 0.5, // this makes bar width 50% of length between ticks
				},
			},
			axis: {
				x: {
					type: "category", // this needed to load string x value
					/* label: {
						text: 'Departments',
						position: 'outer-center'
					} */
				},
			},
		});
	}

	buildGraph(res)
	{
		if (res != null)
		{
			// Reset
			this.viewModel.total_hours_in_department(0);
			this.viewModel.outstanding_hours(0);
			this.viewModel.overtime(0);

			let label_array = ["x"];
			let date_array = ["Total Hours "];
			let total_hours_worked = 0;
			let total_target_hours = 0;

			for (let i = 0; i < res.length; i++)
			{
				total_hours_worked += res[i].total_hours;
				total_target_hours += res[i].target_hours;
			}

			if (this.viewModel.selected_graph_options.indexOf(0) !== -1)
			{
				// Include data for Target vs Actual
				label_array.push("Total Hours Worked");
				date_array.push(total_hours_worked);
				label_array.push("Target Hours");
				date_array.push(total_target_hours);
			}

			if (this.viewModel.selected_graph_options.indexOf(1) !== -1)
			{
				// Include data for Overtime vs Outstanding
				label_array.push("Overtime");
				date_array.push(this.viewModel.overtime());
				label_array.push("Outstanding Hours");
				date_array.push(
					this.viewModel.outstanding_hours_in_department()
				);
			}

			
			// Update the viewModel values
			this.viewModel.total_hours_in_department(total_hours_worked);
			this.viewModel.outstanding_hours(total_target_hours);
			this.viewModel.outstanding_hours_in_department(total_target_hours - total_hours_worked);

			this.chart.unload(); // Clear chart

			setTimeout(() => {
				this.chart.load({columns: [label_array, date_array], type: "bar",});
			}, 1100);
		}
		else
		{
			this.chart.unload();
			this.viewModel.total_hours_in_department(0);
			this.viewModel.outstanding_hours(0);
			this.viewModel.overtime(0);
		}
	}

	// Update chart and other values
	async updateGraphAndValues()
	{
		// Calculate total target hours and total actual hours
		let total_target_hours = this.viewModel.calculate_total_target_hours();
		let total_actual_hours = this.viewModel.calculate_total_actual_hours();
		let outstanding_hours_department = total_target_hours - total_actual_hours;
		
		outstanding_hours_department = Math.max(0, outstanding_hours_department);
		this.viewModel.outstanding_hours_in_department(outstanding_hours_department);

		// Update ViewModel values
		this.viewModel.total_hours_in_department(total_actual_hours);
		this.viewModel.outstanding_hours(total_target_hours - total_actual_hours);
		this.viewModel.overtime(total_actual_hours - total_target_hours);

		let selected_options = this.viewModel.selected_graph_options();

		// Update the chart based on selected options
		let columns = [["x"], ["Department"]];

		if (selected_options.indexOf(0) !== -1)
		{
			columns.push(["Total Hours Worked", total_actual_hours]);
			columns.push(["Target Hours", total_target_hours]);
		}

		if (selected_options.indexOf(1) !== -1)
		{
			columns.push(["Overtime", this.overtime()]);
			columns.push(["Outstanding Hours", outstanding_hours_department]);
		}

		this.chart.load({
			columns: columns,
			type: "bar",
			unload: true,
		})
	}
}

export default {
	route: "[/]report/target_hours_actaul_hours",
	page_class: TargetVsActualHoursPage,
	template: template,
	template_filename: "translation/target_vs_actual_time_report",
};